export type SuppliersKeysDetailArgs = {
  partnerId: string;
  schoolId: string;
};

export const suppliersKeys = {
  all: ["suppliers"] as const,
  details: () => [...suppliersKeys.all, "detail"] as const,
  detail: ({ partnerId, schoolId }: SuppliersKeysDetailArgs) =>
    [...suppliersKeys.details(), partnerId, schoolId] as const
};
